import PropTypes from "prop-types";
import React from "react";

export const NEW = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path d="M6.60156 12H8.55664V2.64355H6.73486V9.17529L3.00879 2.64355H0.958496V12H2.78027V5.354L6.60156 12ZM16.8975 7.91211H12.3525V10.3179H17.5322V12H10.4419V2.64355H17.3037V4.30029H12.3525V6.28711H16.8975V7.91211ZM28.1582 2.64355H30.145L27.5107 12H25.6445L24.5146 6.52832L24.1846 4.71924L23.8545 6.52832L22.7246 12H20.9092L18.2559 2.64355H20.3315L21.5693 8.00098L21.8359 9.49268L22.1089 8.03271L23.1626 2.64355H25.2256L26.3364 8.00098L26.6221 9.49268L26.9077 8.05811L28.1582 2.64355Z" />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "0 0 32 18",
    };
  }
};

NEW.displayName = "NEWIcon";

NEW.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

NEW.defaultProps = { role: "img" };
